import { RefObject, useEffect, useState } from 'react'

import { Nullable } from '@types'

interface ElementSizeProps {
  elementWidth?: number
  elementHeight?: number
}

export const useElementResize = (ref: RefObject<Nullable<HTMLDivElement>>) => {
  const [size, setSize] = useState<ElementSizeProps>({ elementWidth: undefined, elementHeight: undefined })

  useEffect(() => {
    if (ref.current) {
      const element = ref.current

      const handleResize = (entries: { contentRect: { width: number; height: number } }[]) => {
        const entry = entries[entries.length - 1]
        setSize({
          elementWidth: entry.contentRect.width,
          elementHeight: entry.contentRect.height,
        })
      }

      const observer = new ResizeObserver(handleResize)

      observer.observe(element)

      return () => observer.disconnect()
    }

    return undefined
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref.current])

  return size
}
